import { useEffect, useRef } from 'react'
import animationData from './data.json'
import Lottie from '~/components/Lottie'

const defaultLottieOptions = {
  animationData,
  loop: true,
  autoplay: true,
}
const LottieLoading = (props: { height?: number }) => {
  const { height = 60 } = props
  const lottieRef = useRef<any>(null)

  useEffect(() => {
    lottieRef.current?.play()
  }, [])

  return (
    <Lottie
      {...defaultLottieOptions}
      lottieRef={lottieRef}
      style={{ height }}
    />
  )
}

export default LottieLoading
